/**
 * After a deploy, an open tab still runs the old index and asks for lazy chunks that the
 * new build removed. Depending on the server that is a 404 or (prod nginx `try_files $uri
 * /index.html`) an HTML page, and the route fails to load. Reload once to pick up the new
 * index; record the attempt so a chunk that is really broken cannot cause a reload loop.
 */
export const RELOAD_KEY = 'church:chunk-reload-at'
export const RELOAD_WINDOW_MS = 10_000

const PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /is not a valid JavaScript MIME type/i,
]

export function isChunkLoadError(err) {
  if (!err || typeof err.message !== 'string') return false
  return PATTERNS.some((re) => re.test(err.message))
}

export function installChunkReload({ target, storage, reload, router, now = () => Date.now() }) {
  // `target`: the route the failed navigation was heading to (reload straight into it), or
  // undefined to reload the current page.
  function tryReload(target) {
    try {
      const last = Number(storage.getItem(RELOAD_KEY) || 0)
      if (now() - last < RELOAD_WINDOW_MS) return false
      storage.setItem(RELOAD_KEY, String(now()))
    } catch {
      return false
    }
    reload(target)
    return true
  }
  target.addEventListener('vite:preloadError', (event) => {
    if (tryReload(undefined)) event.preventDefault()
  })
  if (router) {
    router.onError((err, to) => {
      if (isChunkLoadError(err)) tryReload(to?.fullPath)
    })
  }
}
